import React, { useState, useEffect, useContext } from 'react';
import { store, StateProvider } from '../Store';

export default function FooterBottom() {

  const STORAGE_CONFIG = `config/${window.REACT_APP_WEB_FOLDER || ""}`;
  const [configData, setConfigData] = useState(JSON.parse(localStorage.getItem(STORAGE_CONFIG)));

  useEffect(() => {
    setConfigData(JSON.parse(localStorage.getItem(STORAGE_CONFIG)));
  }, []);

  const styleTheme = {
    'link': `${configData?.theme && configData.theme}-link`
  }

  return (
    <div className={ "odisea-page-footer-bottom" }>
      {/*
        <p>Powered by <a className={styleTheme.link} href="https://www.cepal.org/en/topics/redatam" target="_blank">REDATAM</a> | <a href="/odisea/terminos-y-condiciones" className={styleTheme.link} > Términos y condiciones </a> | <a href="/odisea/contacto" className={styleTheme.link} > Contacto</a> | © 1985 - 2022 | CELADE, Population Division of ECLAC - United Nations. All rights reserved. </p>
      */}
      <p className={styleTheme.link}><div dangerouslySetInnerHTML={{__html: configData?.footerContent && configData.footerContent}} /></p>
    </div>
  )
}
